export default __webpack_public_path__ + "static/media/head.9539ed31.ogg";